module.exports = __webpack_public_path__ + "img/1542288310.eb72c9ad.jpg";